// src/utils/attribution.js
//
// First-party UTM/gclid attribution. Captures ad-campaign params from the
// landing URL into localStorage so checkout can stamp them onto the lesson
// record. Knows nothing about Google/gtag. Every export is no-throw:
// attribution must never break app boot or the booking flow.

const STORAGE_KEY = "crescendo_attribution";
const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];

const readStored = () => {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  return raw ? JSON.parse(raw) : null;
};

export function captureAttribution() {
  try {
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");
    const hasUtm = UTM_KEYS.some((key) => params.get(key));
    if (!gclid && !hasUtm) return;

    // Google Ads auto-tagging sends only gclid (no utm_*); label those
    // google/cpc so the report doesn't file paid clicks under organic.
    const touch = {
      source: params.get("utm_source") || (gclid ? "google" : null),
      medium: params.get("utm_medium") || (gclid ? "cpc" : null),
      campaign: params.get("utm_campaign") || null,
      term: params.get("utm_term") || null,
      content: params.get("utm_content") || null,
      gclid: gclid || null,
      landingPage: window.location.pathname + window.location.search,
      timestamp: new Date().toISOString(),
    };

    let stored = null;
    try {
      stored = readStored();
    } catch (err) {
      stored = null; // corrupt JSON — start fresh
    }

    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        firstTouch: stored && stored.firstTouch ? stored.firstTouch : touch,
        lastTouch: touch,
      })
    );
  } catch (err) {
    // localStorage unavailable or URL parsing failed — skip silently.
  }
}

export function getAttribution() {
  try {
    return readStored();
  } catch (err) {
    return null;
  }
}
